import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Pagination from "../Pagination/pagination";
import ListControls from "../ListControls/ListControls";
import ExportCsvButton from "../ExportCsvButton";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Loader from "../../Loader/Loader";
import { blockuser, deleteuser, vendorlist, exportStoresCsv } from "../../service/Mainservice";
import moment from "moment";
import Deletepopup from "./Aresure";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import "./Vendor.css";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StarIcon from "@mui/icons-material/Star";
import Tooltip from "@mui/material/Tooltip";
import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const VendorList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [pagination, setpagination] = useState({ page: 1 });
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [id, setid] = useState();
  const [showdelete, setshowdelete] = useState(false);

  // Filter states
  const [searchvalue, setsearchvalue] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [locationFilter, setLocationFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const navigate = useNavigate();

  useEffect(() => {
    getData(1);
  }, [searchvalue, categoryFilter, locationFilter, statusFilter, sortBy, sortOrder]);

  const getData = async (page) => {
    try {
      setloading(true);
      const response = await vendorlist(
        page,
        searchvalue,
        categoryFilter,
        locationFilter,
        statusFilter,
        { sortBy, sortOrder },
      );
      setData(response.data.data);
      setpagination(response.data.pagination);
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error?.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handledelete = async () => {
    try {
      await deleteuser(id, "vendor");
      getData(1);
      setshowdelete(false);
    } catch (error) {
      setshowdelete(false);
    }
  };

  const handleunblock = async (id, action) => {
    try {
      await blockuser(id, "vendor", action);
      getData(1);
    } catch (error) {
      // handle error
    }
  };

  const onClose = () => {
    setshowdelete(false);
  };

  // Navigate to store details
  const handleRowClick = (item) => {
    navigate("/Store_Details", {
      state: { item },
    });
  };

  // Helper for store status
  const getStoreStatus = (item) => {
    if (item.isBlocked)
      return { label: "Blocked", className: "status_blocked" };
    if (!item.isStoreOpen)
      return { label: "Closed", className: "status_closed" };
    if (item.busyMode) return { label: "Busy", className: "status_busy" };
    if (item.pauseNewOrders)
      return { label: "Paused", className: "status_paused" };
    return { label: "Open", className: "status_open" };
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Stores</h1>
          <div className="searchicon">
            <SearchIcon />
            <input
              type="search"
              placeholder="Search by name, owner, email..."
              id="search"
              onChange={(e) => setsearchvalue(e.target.value)}
              autoComplete="off"
            />
          </div>
        </div>

        <ListControls sortOptions={[{value:"createdAt",label:"Created date"},{value:"shopName",label:"Store name"},{value:"fullName",label:"Owner"},{value:"email",label:"Email"},{value:"isVerify",label:"Verification"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
        <ExportCsvButton exportRequest={exportStoresCsv} filters={{ search: searchvalue, status: statusFilter === "all" ? "" : statusFilter, category: categoryFilter === "all" ? "" : categoryFilter, location: locationFilter, sortBy, sortOrder }} filename="stores.csv" />
        {/* Filters */}
        <div className="filters_row">
          <div className="filter_group">
            <label>Category</label>
            <select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="all">All Categories</option>
              <option value="food">Food</option>
              <option value="grocery">Grocery</option>
              <option value="clothing">Clothing</option>
              <option value="electronics">Electronics</option>
              <option value="health">Health</option>
            </select>
          </div>
          <div className="filter_group">
            <label>Location</label>
            <input
              type="text"
              placeholder="City or State"
              value={locationFilter}
              onChange={(e) => setLocationFilter(e.target.value)}
            />
          </div>
          <div className="filter_group">
            <label>Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="pending approval">Pending</option>
              {/* Add 'blocked' if needed, but it's not part of API status field */}
            </select>
          </div>
        </div>

        {data.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Store</th>
                    <th>Status</th>
                    <th>Sales</th>
                    <th>Products</th>
                    <th>Location</th>
                    <th>Rating</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    {
                      /* const status = getStoreStatus(item); */
                    }
                    return (
                      <tr
                        key={item.id}
                        onClick={() => handleRowClick(item)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="store_info">
                          <div className="store_avatar">
                            {item.shopImage ? (
                              <img src={item.shopImage} alt={item.shopName} />
                            ) : (
                              <StorefrontIcon />
                            )}
                          </div>
                          <div>
                            <div className="store_name">
                              {item.shopName || "Unnamed"}
                            </div>
                            <div className="store_owner">{item.fullName}</div>
                          </div>
                        </td>
                        <td>
                          <span className={`status_badge ${item.status}`}>
                            {item.status}
                          </span>
                        </td>
                        <td>${item.totalSales || 0}</td>
                        <td>{item.productCount || 0}</td>
                        <td>
                          <div className="location_cell">
                            <LocationOnIcon fontSize="small" />
                            <span>
                              {item.address
                                ? item.address.split(",")[0] || item.address
                                : "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="rating_cell">
                            <StarIcon fontSize="small" />
                            <span>{item.totalRating || 0}</span>
                          </div>
                        </td>
                        <td>
                          <div className="action_buttons">
                            <Tooltip title="View Details" arrow>
                              <RemoveRedEyeIcon
                                sx={{
                                  color: "#3b82f6",
                                  fontSize: 25,
                                  cursor: "pointer",
                                  "&:hover": {
                                    color: "#2563eb",
                                    transform: "scale(1.1)",
                                  },
                                  transition: "0.2s",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRowClick(item);
                                }}
                              />
                            </Tooltip>

                            {item.isBlocked ? (
                              <Tooltip title="Unblock User" arrow>
                                <BlockIcon
                                  sx={{
                                    color: "#ef4444",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleunblock(item.id, "unblock");
                                  }}
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Block User" arrow>
                                <CheckCircleIcon
                                  sx={{
                                    color: "#22c55e",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleunblock(item.id, "block");
                                  }}
                                />
                              </Tooltip>
                            )}

                            <Tooltip title="Delete User" arrow>
                              <DeleteIcon
                                sx={{
                                  color: "#ef4444",
                                  fontSize: 27,
                                  cursor: "pointer",
                                  "&:hover": {
                                    color: "#dc2626",
                                    transform: "scale(1.1)",
                                  },
                                  transition: "0.2s",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setid(item.id);
                                  setshowdelete(true);
                                }}
                              />
                            </Tooltip>
                          </div>{" "}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          <p className="nodata">No stores match the current filters.</p>
        )}
      </div>

      <Deletepopup
        isOpen={showdelete}
        setisOpen={setshowdelete}
        handledelete={handledelete}
        onClose={onClose}
      />

      {loading && <Loader />}
    </>
  );
};

export default VendorList;
